module.exports = __webpack_public_path__ + "static/media/3DElements1.c93fc305.svg";